<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card v-if="isSuper&&editItem" header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">編輯管理員</span>
          </div>
          <b-button variant="warning" class="border float-right" @click="editItem=null">取消</b-button>
        </template>
        <b-row>
          <b-col md="6" offset-md="3">
            <b-form @submit.prevent="onSubmit">
              <b-form-group
                id="username-input-group"
                label-for="username-input"
                class="mb-3"
                :state="Boolean(editItem.editUsername.length)"
              >
                <template slot="label">管理者帳號</template>
                <b-form-input
                  id="username-input"
                  v-model="editItem.editUsername"
                  :disabled="Boolean(editItem.id)"
                  :state="Boolean(editItem.editUsername.length)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="name-input-group"
                label-for="name-input"
                class="mb-3"
                :state="Boolean(editItem.editName.length)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>管理者名稱
                </template>
                <b-form-input
                  id="name-input"
                  v-model="editItem.editName"
                  :state="Boolean(editItem.editName.length)"
                  required
                  :disabled="Boolean(isBusy)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="email-input-group"
                label-for="email-input"
                class="mb-3"
                :state="validEmailState"
              >
                <template slot="label">
                  <span class="text-danger">*</span>電子信箱
                </template>
                <b-form-input
                  id="email-input"
                  v-model="editItem.editEmail"
                  :state="validEmailState"
                  required
                  :disabled="Boolean(isBusy)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="!editItem.id"
                id="password-input-group"
                label-for="password-input"
                class="mb-3"
                :state="Boolean(editItem.editPassword.length)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>設置密碼
                </template>
                <b-form-input
                  id="password-input"
                  type="password"
                  v-model="editItem.editPassword"
                  :state="Boolean(editItem.editPassword.length)"
                  required
                  :disabled="Boolean(isBusy)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                v-if="!editItem.id"
                id="re-password-input-group"
                label-for="re-password-input"
                class="mb-3"
                :state="Boolean(editItem.editRePassword===editItem.editPassword)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>重複密碼
                </template>
                <b-form-input
                  id="re-password-input"
                  type="password"
                  v-model="editItem.editRePassword"
                  :state="Boolean(editItem.editRePassword===editItem.editPassword)"
                  required
                  :disabled="Boolean(isBusy)"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="email-input-group"
                label-for="email-input"
                class="mb-3"
                :state="Boolean(editItem.editRole)"
              >
                <template slot="label">
                  <span class="text-danger">*</span>身分權限
                </template>
                <b-form-select
                  v-model="editItem.editRole"
                  :options="roleOptinos"
                  :state="Boolean(editItem.editRole)"
                  :disabled="editItem.editRole==='super'"
                  required
                ></b-form-select>
              </b-form-group>
              <b-button variant="primary" type="submit" class="float-right">送出</b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-else header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left mt-1">
            <span class="mb-0 h3 ml-2">管理員列表</span>
          </div>
          <b-button v-if="isSuper" variant="info" class="border float-right" @click="setEditItem({})">新增管理者</b-button>
        </template>
        <b-navbar toggleable="md">
          <b-navbar-nav>
            <b-nav-form inline class="mr-1">
              <label for="inline-form-input-username">管理者帳號：</label>
              <b-form-input
                id="inline-form-input-username"
                v-model="serachUsername"
                class="mr-2"
              ></b-form-input>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav>
            <b-nav-form inline>
              <label for="inline-form-input-name">管理者名稱：</label>
              <b-form-input
                id="inline-form-input-name"
                v-model="searchName"
                class="mr-2"
              ></b-form-input>
            </b-nav-form>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item class="mr-1">
              <b-button
                 v-if="isSuper"
                :disabled="!selectedArray.length"
                variant="danger"
                size="sm"
                @click="onClickDelete"
              >刪除管理者</b-button>
            </b-nav-item>
            <b-nav-form>
              <b-form-select v-model="each" size="sm">
                <b-form-select-option v-for="n in [10, 20, 30, 50]" :value="n" :key="n">每頁顯示筆數: {{ n }}</b-form-select-option>
              </b-form-select>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-table
          id="user-table"
          bordered
          show-empty
          :empty-text="emptyText"
          hover
          :items="items"
          :fields="fields"
          :busy="Boolean(isBusy)"
          responsive="md"
          class="mt-2"
        >
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle mr-3"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:head(checkbox)>
            <b-form-checkbox id="checkbox-all" @change="onClickSelectAll" :indeterminate="isParticalSelected">選取</b-form-checkbox>
          </template>
          <template v-slot:cell(checkbox)="data">
            <b-form-checkbox
              :id="`checkbox-${data.item.id}`"
              v-model="selectedArray"
              :value="data.item.id"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(role)="data">{{ data.value | RoleFormatter }}</template>
          <template v-slot:cell(ops)="data">
            <b-link @click="setEditItem(data.item)">編輯</b-link>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="each"
          aria-controls="user-table"
          class="float-right"
        ></b-pagination>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import QueryString from 'querystring'
import { EmailRegExp, AdminRoles } from '../../library/Var.js'
import { State } from '../../library/EventBus.js'
export default {
  data () {
    return {
      currentPage: 1,
      rows: 0,
      each: 10,
      searchName: '',
      serachUsername: '',
      items: [],
      isBusy: false,
      selectedArray: [],
      editItem: null,
      errorState: 'no-result'
    }
  },
  computed: {
    emptyText () {
      const state = this.errorState
      if (state === 'no-result') {
        return '尚無資料'
      } else if (state === 'denied') {
        return '當前權限身分無法瀏覽'
      } else {
        return '尚無資料'
      }
    },
    fields () {
      const obj = [
        { key: 'checkbox', label: '選取', tdClass: 'text-center' },
        { key: 'username', label: '管理者帳號', tdClass: 'text-center' },
        { key: 'name', label: '管理者名稱', tdClass: 'text-center' },
        { key: 'email', label: '電子信箱', tdClass: 'text-center' },
        { key: 'role', label: '權限身分', tdClass: 'text-center' }
      ]
      if (this.isSuper) {
        obj.push({ key: 'ops', label: '操作', tdClass: 'text-center' })
      }
      return obj
    },
    query () {
      const obj = {
        page: this.currentPage,
        each: this.each
      }
      if (this.searchName) {
        obj.name = this.searchName
      }
      if (this.serachUsername) {
        obj.username = this.serachUsername
      }
      const str = QueryString.stringify(obj)
      return `?${str}`
    },
    isSuper () {
      return State.user.role === 'super'
    },
    validEmailState () {
      if (!this.editItem) return false
      return EmailRegExp.test(this.editItem.editEmail)
    },
    roleOptinos () {
      const array = []
      for (const key in AdminRoles) {
        array.push({ text: AdminRoles[key], value: key, disabled: key === 'super' })
      }
      return array
    },
    isParticalSelected () {
      return this.items.length !== 0 && this.selectedArray.length !== 0 && this.items.length !== this.selectedArray.length
    }
  },
  methods: {
    start () {
      if (this.isBusy) {
        clearTimeout(this.isBusy)
      }
      this.isBusy = setTimeout(async () => {
        try {
          const { data } = await this.$api.getAdmin(this.query)
          this.items = data
        } catch (err) {
          // denied
          this.errorState = 'denied'
        } finally {
          this.isBusy = false
        }
      }, 2000)
    },
    setEditItem (item) {
      const { username = '', name = '', email = '', role = null } = item
      this.$set(item, 'editUsername', username)
      this.$set(item, 'editName', name)
      this.$set(item, 'editEmail', email)
      this.$set(item, 'editPassword', '')
      this.$set(item, 'editRePassword', '')
      this.$set(item, 'editRole', role)
      this.editItem = item
    },
    async onClickDelete () {
      if (this.isBusy) return
      this.isBusy = true
      const wait = this.selectedArray.map(id => this.$api.delAdmin(id))
      try {
        await Promise.all(wait)
        this.showSuccessBox()
      } catch (err) {
        console.log(err)
        this.showErrorBox()
      }
      this.isBusy = false
      this.selectedArray = []
      this.start()
    },
    async onSubmit () {
      if (this.isBusy) return
      const { id, editName: name, editEmail: email, editRole: role } = this.editItem
      const data = { name, email, role }
      this.isBusy = true
      try {
        if (id) {
          await this.$api.putAdmin(data, id)
        } else {
          const { editUsername: username, editPassword: password } = this.editItem
          data.username = username
          data.password = password
          await this.$api.postAdmin(data)
        }
        this.showSuccessBox()
      } catch (err) {
        console.log(err)
        this.showErrorBox()
      }
      this.editItem = null
      this.isBusy = false
      this.start()
    },
    showSuccessBox () {
      this.$bvToast.toast('資料已更新', {
        variant: 'success',
        title: '操作成功'
      })
    },
    showErrorBox () {
      this.$bvToast.toast('連線錯誤，資料未更新', {
        variant: 'danger',
        title: '操作失敗'
      })
    },
    onClickSelectAll (val) {
      let array = []
      if (val) {
        array = this.items.map(item => item.id)
      }
      this.selectedArray = array
    }
  },
  filters: {
    RoleFormatter (val) {
      return AdminRoles[val] || '異常'
    }
  },
  mounted () {
    this.start()
  },
  watch: {
    query () {
      this.start()
    }
  }
}
</script>
